export const vocabSynonyms: Record<string, string[]> = {
  abate: ['diminish', 'reduce', 'lessen'],
  abandon: ['give up', 'desert', 'leave behind'],
  meticulous: ['careful', 'thorough', 'detailed'],
  compelling: ['persuasive', 'convincing', 'forceful'],
  alleviate: ['ease', 'relieve', 'reduce'],
};

export const getSynonymsFor = (en?: string): string[] => {
  if (!en) return [];
  const key = en.trim().toLowerCase();
  return vocabSynonyms[key] ?? [];
};
